import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeWidth={1.5}
      d="M12 21.565a9.534 9.534 0 0 0 6.808-2.85M12 21.565a9.534 9.534 0 0 1-6.808-2.85M18.808 5.285A9.533 9.533 0 0 1 21.565 12M5.193 5.285A9.533 9.533 0 0 1 12 2.435M12 2.435a9.534 9.534 0 0 1 6.808 2.85M21.565 12a9.534 9.534 0 0 1-2.757 6.715M2.435 12a9.534 9.534 0 0 0 2.757 6.715M5.193 5.285A9.533 9.533 0 0 0 2.435 12M12 16.782c1.377 0 2.702.217 3.949.613M8.052 17.394A13.027 13.027 0 0 1 12 16.782M5.193 18.715c.89-.546 1.844-.998 2.859-1.32M18.808 18.715a13.01 13.01 0 0 0-2.86-1.32M18.808 5.285c-.89.546-1.845.998-2.86 1.32M8.052 6.606c1.246.395 2.572.612 3.948.612M5.193 5.285c.89.546 1.844.998 2.859 1.32M15.948 6.606A13.026 13.026 0 0 1 12 7.218M16.783 12H12M7.218 12H12M7.218 12H2.435M21.565 12h-4.782M12 2.435v4.782M12 21.565v-4.783M12 16.782V12M12 7.217V12M7.218 12c0-2.002.307-3.858.833-5.395"
    />
    <path
      strokeWidth={1.5}
      d="M12 2.435c1.64 0 3.087 1.653 3.949 4.17M15.948 6.605c.526 1.537.834 3.393.834 5.395M16.783 12c0 2.002-.309 3.858-.834 5.395M12 2.435c-1.64 0-3.087 1.653-3.948 4.17M12 21.565c1.64 0 3.087-1.653 3.949-4.17M12 21.565c-1.64 0-3.087-1.653-3.948-4.17M7.218 12c0 2.002.307 3.858.833 5.395"
    />
  </svg>
);

export default SvgComponent;
